import Avatar, { type AvatarProps, getInitialsFromFullName } from './avatar';
import AvatarGroup from './avatar-group';
import InactiveUserAvatar from './inactive-user-avatar';

export { Avatar, AvatarGroup, InactiveUserAvatar, getInitialsFromFullName };
export type { AvatarProps };

export default Avatar;
